import React, { useContext } from 'react';
import TextArea from '../atoms/TextArea';
import InputDecoratorContext from '../context/decorator';
const TextAreaInput = props => {
    const { error } = useContext(InputDecoratorContext);
    const { innerRef, ...inputProps } = props;
    return React.createElement(TextArea, { "$error": Boolean(error), ref: innerRef, ...inputProps, rows: props.rows ?? void 0 });
};
export default TextAreaInput;
